module.exports = __webpack_public_path__ + "img/transit.5c5ca575.jpg";